// extracted by mini-css-extract-plugin
var _1 = "BookPageImage__alex--GohQO BookPageImage__pageImg--Jl2Mw";
var _2 = "BookPageImage__announcer--Oa3rR BookPageImage__pageImg--Jl2Mw";
var _3 = "BookPageImage__announcer2--DBdkZ BookPageImage__pageImg--Jl2Mw";
var _4 = "BookPageImage__carpool--so3_W BookPageImage__pageImg--Jl2Mw";
var _5 = "BookPageImage__channel5--T5K53 BookPageImage__pageImg--Jl2Mw";
var _6 = "BookPageImage__clod--dwS8u BookPageImage__pageImg--Jl2Mw";
var _7 = "BookPageImage__container--KbZoc";
var _8 = "BookPageImage__cropped--iSZf1";
var _9 = "BookPageImage__error--i8hLw";
var _a = "BookPageImage__fiona--Qps7M BookPageImage__pageImg--Jl2Mw";
var _b = "BookPageImage__grogg--mi3Yy BookPageImage__pageImg--Jl2Mw";
var _c = "BookPageImage__grok--kCOTy BookPageImage__pageImg--Jl2Mw";
var _d = "BookPageImage__kraken--xNrq8 BookPageImage__pageImg--Jl2Mw";
var _e = "BookPageImage__lizzie--uOpr_ BookPageImage__pageImg--Jl2Mw";
var _f = "BookPageImage__loading--mdKxz";
var _10 = "BookPageImage__loadingOuter--x9GHv";
var _11 = "BookPageImage__lunch--cNtTg BookPageImage__pageImg--Jl2Mw";
var _12 = "BookPageImage__main--MkMrF";
var _13 = "BookPageImage__mathbowl--VA2AS BookPageImage__pageImg--Jl2Mw";
var _14 = "BookPageImage__mathmeet--tb91H BookPageImage__pageImg--Jl2Mw";
var _15 = "BookPageImage__pageImg--Jl2Mw";
var _16 = "BookPageImage__pageNumber--pEzdd";
var _17 = "BookPageImage__pageParts--TDbIc BookPageImage__pageImg--Jl2Mw";
var _18 = "BookPageImage__pagePartsSingle--rC0sY BookPageImage__pageImg--Jl2Mw";
var _19 = "BookPageImage__pageSingle--HATe4";
var _1a = "BookPageImage__pneumatube--ChANc BookPageImage__pageImg--Jl2Mw";
var _1b = "BookPageImage__q--i8HR_ BookPageImage__pageImg--Jl2Mw";
var _1c = "BookPageImage__recess--Dnvh5 BookPageImage__pageImg--Jl2Mw";
var _1d = "BookPageImage__rg--OS3ts BookPageImage__pageImg--Jl2Mw";
var _1e = "BookPageImage__rote--bfhm3 BookPageImage__pageImg--Jl2Mw";
var _1f = "BookPageImage__schoolbus--d9JMm BookPageImage__pageImg--Jl2Mw";
var _20 = "BookPageImage__ship--wP9JJ BookPageImage__pageImg--Jl2Mw";
var _21 = "BookPageImage__title--rR3hB BookPageImage__pageImg--Jl2Mw";
var _22 = "BookPageImage__training--yOY8q BookPageImage__pageImg--Jl2Mw";
var _23 = "BookPageImage__unknown--HI5gQ BookPageImage__pageImg--Jl2Mw";
var _24 = "BookPageImage__winnie--YiREL BookPageImage__pageImg--Jl2Mw";
var _25 = "BookPageImage__wringer--Iiry9 BookPageImage__pageImg--Jl2Mw";
export { _1 as "alex", _2 as "announcer", _3 as "announcer2", _4 as "carpool", _5 as "channel5", _6 as "clod", _7 as "container", _8 as "cropped", _9 as "error", _a as "fiona", _b as "grogg", _c as "grok", _d as "kraken", _e as "lizzie", _f as "loading", _10 as "loadingOuter", _11 as "lunch", _12 as "main", _13 as "mathbowl", _14 as "mathmeet", _15 as "pageImg", _16 as "pageNumber", _17 as "pageParts", _18 as "pagePartsSingle", _19 as "pageSingle", _1a as "pneumatube", _1b as "q", _1c as "recess", _1d as "rg", _1e as "rote", _1f as "schoolbus", _20 as "ship", _21 as "title", _22 as "training", _23 as "unknown", _24 as "winnie", _25 as "wringer" }
